import React from 'react';
import { Building2, RefreshCw } from 'lucide-react';

export function StatusBadge({ status, dark }) {
  const map = {
    active: dark ? 'text-emerald-300 bg-emerald-500/10' : 'text-emerald-700 bg-emerald-50',
    invited: dark ? 'text-amber-300 bg-amber-500/10' : 'text-amber-700 bg-amber-50',
    none: dark ? 'text-gray-400 bg-gray-500/10' : 'text-gray-600 bg-gray-100',
  };
  return <span className={`px-2 py-0.5 rounded-md text-xs font-medium capitalize ${map[status] || map.none}`}>{status}</span>;
}

export default function CompClientsList({ comps, onResend, theme }) {
  const dark = theme === 'dark';
  if (!comps?.length) {
    return <div className={`rounded-xl border p-8 text-center text-sm ${dark ? 'border-gray-700 text-gray-400' : 'border-gray-200 text-gray-500'}`}>No comped clients yet.</div>;
  }
  return (
    <div className="grid gap-2">
      {comps.map(c => (
        <div key={c.id} className={`flex items-center justify-between px-4 py-3 rounded-xl border ${dark ? 'border-gray-700 bg-gray-800/40' : 'border-gray-200 bg-white'}`}>
          <div className="flex items-center gap-3 min-w-0">
            <Building2 size={18} className="text-gray-400" />
            <div className="min-w-0">
              <div className="font-semibold truncate">{c.company_name}</div>
              <div className={`text-xs truncate ${dark ? 'text-gray-400' : 'text-gray-500'}`}>{c.contact_email || 'no email'}</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <StatusBadge status={c.status} dark={dark} />
            {c.status === 'invited' && (
              <button onClick={() => onResend(c)} className="flex items-center gap-1 text-xs text-blue-600 hover:underline">
                <RefreshCw size={13} /> Resend
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
